module.exports = __webpack_public_path__ + "static/media/developerActivity.51e9bdcc.svg";